import React from 'react';
import {Button, Icon, message} from 'antd';
import {WeaDialog, WeaSearchGroup, WeaFormItem, WeaInput, WeaTable} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import WeaMaterialLib from './base/WeaMaterialLib';

// 幻灯片详细设置
export default class Content_Slide_detail extends React.Component {
    state = {
        eSlideDetail: this.props.eSlideDetail
    };

    constructor(props) {
        super(props);
        this.getButtons = this.getButtons.bind(this);
        this.onOk = this.onOk.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    render() {
        const columns = [{
            title: getLabel(26283, '主图片'),
            dataIndex: 'mainImage',
            render: (text, record) => (
                <WeaMaterialLib value={text} onChange={this.onDetailChange.bind(this, record.key, 'mainImage')}/>
            )
        }, {
            title: getLabel(26284, '导航样式背景图'),
            dataIndex: 'bgImage',
            render: (text, record) => (
                <WeaMaterialLib value={text} onChange={this.onDetailChange.bind(this, record.key, 'bgImage')}/>
            )
        }, {
            title: getLabel(386598, '导航样式前景图'),
            dataIndex: 'fgImage',
            render: (text, record) => (
                <WeaMaterialLib value={text} onChange={this.onDetailChange.bind(this, record.key, 'fgImage')}/>
            )
        }, {
            title: getLabel(24986, '标题'),
            dataIndex: 'title',
            render: (text, record) => (
                <WeaInput value={text} onChange={this.onDetailChange.bind(this, record.key, 'title')}/>
            )
        }, {
            title: getLabel(433, '描述'),
            dataIndex: 'desc',
            render: (text, record) => (
                <WeaInput value={text} onChange={this.onDetailChange.bind(this, record.key, 'desc')}/>
            )
        }, {
            title: getLabel(22932, '图片链接'),
            dataIndex: 'link',
            render: (text, record) => (
                <WeaInput value={text} onChange={this.onDetailChange.bind(this, record.key, 'link')}/>
            )
        }];

        return (
            <WeaDialog
                className="portal-esetting-dialog"
                visible={true}
                title={getLabel(19342, '详细设置')}
                icon="icon-coms-portal"
                iconBgcolor='#1a57a0'
                style={{width: 1037, height: 492}}
                zIndex={1000}
                hasScroll={true}
                buttons={this.getButtons()}
                onCancel={this.onCancel}
            >
                <WeaTable columns={columns} dataSource={this.state.eSlideDetail} pagination={false}/>
                <div style={{margin: '25px'}}>
                    <div>
                        <p><span className="portal_slide_detail">{getLabel(125776,"说明:")}</span></p>
                        <p><span className="portal_slide_detail">{getLabel(390855,"1、建议主图片大小为2000像素*160像素")}</span></p>
                        <p><span className="portal_slide_detail">{getLabel(390856,"2、建议导航样式背景图大小为150像素*40像素")}</span></p>
                        <p><span className="portal_slide_detail">{getLabel(390857,"3、建议导航样式前景图大小为165像素*40像素")}</span></p>
                        <p><span className="portal_slide_detail">{getLabel(502246,"4、设置了主图片，建议设置导航图")}</span></p>
                    </div>
                </div>
            </WeaDialog>
        );
    }

    getButtons() {
        let buttons = [];
        buttons.push(<Button type="primary" onClick={this.onOk}>{getLabel(826, '确定')}</Button>);
        buttons.push(<Button type="ghost" onClick={this.onCancel}>{getLabel(31129, '取消')}</Button>);
        return buttons;
    }

    onDetailChange(key, type, value) {
        const {eSlideDetail} = this.state;
        eSlideDetail[key][type] = value;
        this.setState({eSlideDetail: eSlideDetail});
    }

    onOk() {
        this.props.onOk(this.state.eSlideDetail);
    }

    onCancel() {
        this.props.onCancel();
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_Slide_detail.js